module.exports = '1.1.1';



// WEBPACK FOOTER //
// ./~/sockjs-client/lib/version.js